<template>
  <div class="docmanager">
    <template v-if="collection">
      <div v-if="!isPlacementMode" style="display: flex; flex-direction: row">
        <div class="toc__heading--content">Saved snippets</div>
        <button
          class="toc__heading--button"
          style="background-color: white"
          @click="$emit('toggleToC')"
        >
          hide
        </button>
      </div>
      <div v-if="!isPlacementMode">
        <div v-for="(doc, index) in collection.docs" :key="doc.id" class="docmanager__docs">
          <!-- <div class="docmanager__docname">{{ doc.name }}</div> -->
          <TableOfContents
            :document="doc"
            :index="index"
            @addNode="addDocNode(doc.id, $event)"
            @deleteNode="deleteDocNode(doc.id, $event)"
            @deleteNodes="deleteDocNodes(doc.id, $event)"
            @toggleToC="$emit('toggleToC')"
          />
        </div>
      </div>
      <div v-if="isPlacementMode && selectedSlide">
        <div v-for="(doc, index) in collection.docs" :key="doc.id" class="docmanager__docs">
          <TableOfContents
            v-if="selectedSlide.id == doc.id"
            :document="doc"
            :index="index"
            @addNode="addDocNode(doc.id, $event)"
            @deleteNode="deleteDocNode(doc.id, $event)"
            @deleteNodes="deleteDocNodes(doc.id, $event)"
            @toggleToC="$emit('toggleToC')"
            :isPlacementMode="true"
            @updatePlaceWhere="$emit('updatePlaceWhere', $event)"
          />
        </div>
      </div>
    </template>

    <div class="docmanager__new-doc">
      <!--Notes - this was left by Stuart as a way to let interaction start from the ToC. Can be revived-->
      <!--<button v-if="!showAddDoc" @click="showAddDoc = true">New slide</button>-->

      <div class="docmanager__new-doc-add" v-if="showAddDoc">
        <div v-if="templates">
          <h2>Select template</h2>
          <ul class="docmanager__templates">
            <li
              v-for="name in Object.keys(templates)"
              :key="name"
              class="docmanager__template-option"
              :class="{
                'docmanager__template-option--selected': newDocTemplate == name,
              }"
            >
              <label>
                {{ name }}
                <input type="radio" v-model="newDocTemplate" :value="name" />
              </label>
            </li>
          </ul>
        </div>

        <label>
          Name
          <input v-model="newDocName" />
        </label>
        <button @click="addDoc">Add</button>
      </div>
    </div>
  </div>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep';
import PigeonDocModel from '../../models/PigeonDocModel';
import PigeonDocCollectionModel from '../../models/PigeonDocCollectionModel';
import TableOfContents from '../TableOfContents/TableOfContents';

export default {
  name: 'DocManager',
  components: {
    TableOfContents,
  },
  props: {
    collectionId: {
      default: () => '',
      type: String,
    },
    value: {
      default: () => [],
      type: Array,
    },
    templates: {
      default: () => {},
      type: Object,
    },
    isPlacementMode: {
      default: () => false,
      type: Boolean,
    },
    selectedSlide: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      collection: null,
      showAddDoc: false,
      newDocName: null,
      newDocTemplate: null,
    };
  },
  async created() {
    if (this.value && this.value.length && this.collectionId) {
      throw new Error(
        'DocManager component has been passed documents and a collectionId. Please only use one method.',
      );
    }

    if (this.collectionId) {
      this.collection = await this.$pigeonline.projects.getByID(
        PigeonDocCollectionModel,
        this.collectionId,
      );
    }

    if (!this.collectionId) {
      if (this.value) {
        const saved = await this.saveNewDocs(this.value);

        if (saved) {
          const collection = new PigeonDocCollectionModel({ docs: saved });

          this.collection = await this.$pigeonline.projects.create(collection);

          this.$emit('input', _cloneDeep(saved));

          if (this.collection.docs && this.collection.docs.length) {
            this.$emit('toggleToC');
          }
        }
      }
    }
  },
  watch: {
    collectionId(val, oldVal) {
      // is this needed given we are curently testing with not creating this node until the prop is filled
      if (val !== oldVal) {
        this.collection = val;
      }
    },
    value: {
      handler() {
        this.collection.docs = this.value;
      },
      deep: true,
    },
    'collection.docs': {
      async handler() {
        // Load docs for ids in collection
        const toLoad = this.collection.docIds.filter(
          (id) => !this.collection.docs.some((doc) => doc.id == id),
        );

        if (toLoad.length) {
          // hacky fix to two different versions arriving, one with string and another the whole object
          if (toLoad.some((loadThis) => !loadThis.id)) {
            const loaded = await Promise.all(
              toLoad.map((id) => this.$pigeonline.projects.getByID(PigeonDocModel, id)),
            );
            this.collection.add(...loaded);
            this.$emit('input', _cloneDeep(this.collection.docs));
          }
        }

        const saved = await this.saveNewDocs(this.collection.docs);

        if (saved) {
          this.collection.docs = saved;
          this.$emit('input', _cloneDeep(this.collection.docs));
        }

        // If docIds have changed, save collection. -> note in currenct functionality this does not work
        // This may be helpful when we 'save' from the report view, but let's see.
        // if (oldDocs) {
        // if (!_isEqual(newDocs.map(el => el.id), oldDocs.map(el => el.id))) {
        // this.save()
        // }
        // }
      },
    },
  },
  methods: {
    async addDoc() {
      this.collection.add(
        new this.templates[this.newDocTemplate]({
          name: this.newDocName,
        }),
      );

      this.showAddDoc = false;
    },
    async save() {
      try {
        if (this.collection.id) {
          const project = await this.$pigeonline.projects.update(this.collection);
          this.collection = project;
        } else {
          const project = await this.$pigeonline.projects.create(this.collection);
          this.collection = project;
        }
      } catch (e) {
        //console.error(e);
        this.saveError = true;
      }
    },
    async saveNewDocs(docs) {
      const unsavedDocs = docs.filter((doc) => !doc.id);

      if (unsavedDocs.length > 0) {
        const saved = await Promise.all(
          docs.map(async (doc) =>
            // If saved version exists return, otherwise return promise that will resolve
            // with saved doc.
            doc.id ? doc : this.$pigeonline.projects.create(doc),
          ),
        );

        return saved;
      } else {
        return false;
      }
    },
    addDocNode(docId, node) {
      const doc = this.collection.docs.find((doc) => doc.id == docId);
      doc.nodes.push(node);
      this.$emit('input', _cloneDeep(this.collection.docs));
    },
    deleteDocNode(docId, node) {
      const doc = this.collection.docs.find((doc) => doc.id == docId);
      doc.removeNode(node);
      this.$emit('input', _cloneDeep(this.collection.docs));
    },
    deleteDocNodes(docId, nodes) {
      if (nodes.length) {
        let docDetails = {
          docId,
          nodes,
        };
        this.$emit('deleteTheseNodes', docDetails);
      }
    },
    async refresh() {
      if (this.collectionId) {
        this.collection = await this.$pigeonline.projects.getByID(
          PigeonDocCollectionModel,
          this.collectionId,
        );
      }
    },
  },
};
</script>

<style>
.docmanager {
  display: inline-flex;
  flex-direction: column;
  position: relative;
  margin: 0.5rem 0;
  width: 100%;
  font-size: 0.8rem;
}

.docmanager__docs {
  display: flex;
}
.docmanager__docname {
  font-size: 0.7rem;
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  margin: 0;
  margin-left: 0.5rem;
  margin-top: 3.5rem;
  margin-bottom: auto;
}
.docmanager__templates {
  list-style-type: none;
  padding: 0;
  display: flex;
}

.docmanager__new-doc {
  text-align: center;
}

.docmanager__new-doc-add {
  position: absolute;
  background: white;
  z-index: 9;
}
.docmanager__template-option {
  display: inline;
  border: 1px #444 solid;
  padding: 1ch;
  margin: 0.25rem;
}
.docmanager__template-option--selected {
  background: #bbb;
}
.docmanager__template-option input {
  display: none;
}
</style>
